const logger = console;

export { logger as l };
